jQuery('.page-customizable-mattresses .combo-visual').hide();
// jQuery('.page-customizable-mattresses-2 .combo-visual').hide();
jQuery('.page-customizable-mattresses .gallery-wrap').show();
jQuery('.page-customizable-mattresses-2 .gallery-wrap').show();

// When user selects from either dropdown
jQuery('.page-customizable-mattresses .first-selector .dropdown-item, .page-customizable-mattresses .second-selector .dropdown-item').on('click', function() {
  jQuery('.page-customizable-mattresses .combo-visual').show();   // Show combo visual with fade
  jQuery('.page-customizable-mattresses .gallery-wrap').hide();  // Hide gallery smoothly
});

jQuery('.page-customizable-mattresses-2 .first-selector .dropdown-item, .page-customizable-mattresses-2 .second-selector .dropdown-item').on('click', function() {
  jQuery('.page-customizable-mattresses-2 .product__images').addClass('sleeper-selected');
  // jQuery('.page-customizable-mattresses-2 .combo-visual').show();   // Show combo visual with fade
  // jQuery('.page-customizable-mattresses-2 .product_gallery').hide();  // Hide gallery smoothly
});
jQuery('.page-customizable-mattresses-2 .product-gallery__thumbnail').on('click', function() {
  jQuery('.page-customizable-mattresses-2 .product__images').removeClass('sleeper-selected');
});

// (function () {
//   // Mobile only
//   if (window.innerWidth > 441) return;
//
//   // Page restriction
//   if (!document.body.classList.contains('page-customizable-mattresses-2')) return;
//
//   function applyOffset() {
//     var iframe = document.querySelector('iframe[title="chat widget"]');
//     if (iframe) {
//       iframe.style.bottom = '95px';
//     }
//   }
//
//   // Initial attempt
//   applyOffset();
//
//   // Observe DOM changes caused by Tawk open/close
//   var observer = new MutationObserver(function () {
//     applyOffset();
//   });
//
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();

jQuery(document).ready(function(){
  jQuery('.product-gallery__video video').each(function() {
    var $video = jQuery(this);

    // Ensure muted for autoplay
    $video.prop('muted', true);
    $video.prop('loop', true);

    // Try playing the video
    $video[0].play().catch(function() {
      console.log('Autoplay blocked');
    });

    // Extra safety: restart video if it ends (some Shopify JS may override loop)
    $video.on('ended', function() {
      this.currentTime = 0;
      this.play();
    });
  });
});

// Explore Mattress hero quick wins — Aug 27 2026, this page only.
jQuery(document).ready(function(){
  if (!document.body.classList.contains('page-customizable-mattresses-2')) return;

  // Shipping details are covered lower on the page; keep the hero focused.
  jQuery('.free-shipping').remove();

  // Collect special instructions at cart instead of in the mattress configurator.
  jQuery('label[for="evrbed-order-notes"], #evrbed-order-notes').remove();

  var $heading = jQuery('h1.main-custom-evrbd').first();
  if (!$heading.length) return;

  $heading.text('Evrbed Modular Mattress');

  var $subhead = $heading.next('h3');
  if ($subhead.length) {
    $subhead.text('Personalized comfort for each sleeper. Adjustable over time.');
  }

  var $trust = $subhead.next('div');
  if ($trust.length) {
    $trust.text('Making Mattresses Since 1976');
  }

  // Small, explicit carousel controls on the main image only.
  if (!document.getElementById('evrbed-gallery-arrow-styles')) {
    jQuery('<style id="evrbed-gallery-arrow-styles">' +
      '@media (min-width: 769px) {' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button {' +
          'display:block !important;position:absolute !important;top:50% !important;bottom:auto !important;transform:translateY(-50%) !important;' +
          'width:38px !important;height:38px !important;min-width:38px !important;max-width:38px !important;min-height:38px !important;max-height:38px !important;' +
          'padding:0 !important;margin:0 !important;box-sizing:border-box !important;overflow:hidden !important;' +
          'background:rgba(255,255,255,0.88) !important;border:1px solid rgba(15,71,93,0.18) !important;border-radius:999px !important;' +
          'box-shadow:0 2px 8px rgba(0,0,0,0.10) !important;opacity:0.95 !important;font-size:0 !important;z-index:4 !important;' +
        '}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button.previous {left:12px !important;right:auto !important;}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button.next {right:12px !important;left:auto !important;}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button svg {' +
          'display:none !important;' +
        '}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button::before {' +
          'position:absolute;left:50%;top:50%;transform:translate(-50%,-54%);color:#0f475d;font-size:28px;font-weight:400;line-height:1;' +
        '}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button.previous::before {content:"‹";}' +
        '.page-customizable-mattresses-2 .product_gallery.flickity-enabled .flickity-prev-next-button.next::before {content:"›";}' +
      '}' +
    '</style>').appendTo('head');
  }
});
